import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

const ModalConfirm = ({ open, toggle, title, message, onConfirm }) => {
  const handleAction = action => {
    if (action == "confirm") {
      onConfirm();
    }
    toggle();
  };
  return (
    <Modal isOpen={open} toggle={toggle}>
      <ModalHeader toggle={toggle}>{title}</ModalHeader>
      <ModalBody>
        <p>{message}</p>
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={() => handleAction("cancel")}>
          Cancel
        </Button>
        <Button color="primary" onClick={() => handleAction("confirm")}>
          Confirm
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalConfirm;
